const Table = ({ attributes, children }) => {
  return (
    <table>
      <tbody {...attributes}>{children}</tbody>
    </table>
  );
};

export default Table;
